import { GoogleAnalyticsService } from './../../services/google-analytics/google-analytics.service';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { OrganizationTypesEnum } from './../../enum/organization-types.enum';
import { CRUDActionsEnum } from '../../enum/crud-actions.enum';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { AnnouncementsService } from '../../services/announcements/announcements.service';
import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ScrollDispatcher, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { filter } from 'rxjs/operators';
import * as _ from 'lodash';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { HeaderService } from '../../services/header/header.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(private _announcementService: AnnouncementsService,
    private _flashMessage: FlashMessageService,
    private scrollDispatcher: ScrollDispatcher,
    private location: Location,
    public header: HeaderService,
    private _redirectUrl: RedirctUrlService,
    private _gaSvc: GoogleAnalyticsService,
    private _cd: ChangeDetectorRef,
    private _currentUserService: CurrentUserService,
    public appNotificationsService: AppNotificationService) { }

  public announcements: any[] = [];
  public organizationTypes = OrganizationTypesEnum;
  public organizationType: string;
  public currentUser: string;
  public activeTab: string;
  public editingAnnouncement: string;
  public createNew: boolean;
  public page: number;
  public loading: boolean;
  public saveLoading: boolean;
  public lockScroll: boolean;
  public roleCode: string;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) scroll: CdkVirtualScrollViewport;
  private _scrollSubscriber: Subscription;
  private _getAnnouncementSubscriber: Subscription;
  private _saveAnnouncementSubscriber: Subscription;
  private _deleteAnnouncementSubscriber: Subscription;
  public notifications: any[] = [];
  public entitlements = [];

  async ngOnInit() {
    this._currentUserService.getUser().then(user => {
      let entitlementObs = _.get(user, 'role.entitlements', []);
      this.entitlements = entitlementObs.map(entitlemtnt => entitlemtnt.code).reduce((a, b) => (a[b] = true, a), {});

      this.organizationType = user.organizationType;
      this.roleCode = user.role.code;
      this.currentUser = user.firstname;
      this._initAnnouncement();
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngAfterViewInit() {
    // subscribed to scroll to check for reaching bottom of scroll
    this._scrollSubscriber = this.scrollDispatcher.scrolled().pipe(
      filter(() => this.scroll.measureScrollOffset('bottom') <= 1)
    ).subscribe(() => {
      // avoid calling api if its already loading data or scroll is locked
      if (!this.loading && !this.lockScroll) {
        this._getAnnouncements();
      }
    });

    this._gaSvc.register(`Announcements`, `${this._currentUserService.toTitleCase(this.organizationType)} user navigated to announcement page`);
  }

  ngOnDestroy(): void {
    if (this._scrollSubscriber) this._scrollSubscriber.unsubscribe();
    if (this._deleteAnnouncementSubscriber) this._deleteAnnouncementSubscriber.unsubscribe();
    if (this._getAnnouncementSubscriber) this._getAnnouncementSubscriber.unsubscribe();
    if (this._saveAnnouncementSubscriber) this._saveAnnouncementSubscriber.unsubscribe();

  }

  public onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  public onBackEventHandler() {
    this.location.back();
  }

  public checkPrivilege(entitlement) {
    if (!this.entitlements || !entitlement) return false;
    return this.entitlements[entitlement];
  }

  public canPost(): boolean {
    if (this.organizationType === this.organizationTypes.INTERNAL) {
      return this.checkPrivilege('HC_INTERNAL_CREATE_ANNOUNCEMENTS');
    }
    else return false
  }

  public canEdit(): boolean {
    if (this.organizationType === this.organizationTypes.INTERNAL) {
      return this.checkPrivilege('HC_INTERNAL_UPDATE_ANNOUNCEMENTS');
    }
    else return false
  }

  private _initAnnouncement() {
    this.activeTab = this.canPost() ? this._getDefaultActiveTab() : this.organizationType;
    this._resetPage();
    this._getAnnouncements();
  }

  private _getDefaultActiveTab(){
    if (this.checkPrivilege('HC_CUSTOMER_VIEW_USER')) {
      return this.organizationTypes.CUSTOMER;
    } else if (this.checkPrivilege('HC_SUPPLIER_VIEW_USER')) {
      return this.organizationTypes.SUPPLIER;
    } else if (this.checkPrivilege('HC_CR_VIEW_USER')) {
      return this.organizationTypes.CARRIER;
    } else {
      return this.organizationType;
    }
  }

  public createNewAnnouncement() {
    this.createNew = true;
  }

  /**
   * On Customer/Supplier tabs changed
   * @param tab
   */
  public onTabsChange(tab: string): void {
    this.activeTab = tab;
    this.announcements = [];
    this._lockScroll(false);
    this._resetPage();
    this._getAnnouncements();
  }

  /**
   * On Save/Create button clicked
   * @param $event
   */
  public onAnnouncementSave($event: any): void {
    if ($event.action === CRUDActionsEnum.CANCEL) {
      this.createNew = false;
      this.editingAnnouncement = null;
    } else if ($event.action === CRUDActionsEnum.SAVE) {
      this.saveLoading = true;
      this._saveAnnouncementSubscriber = this._announcementService.updateAnnouncement(this.editingAnnouncement, $event.data, this.activeTab).subscribe((data:any) => {
        this.createNew = false;
        this.saveLoading = false;
        let priority = data.priority === 1 ? true : false
        // If its editing existing announcement replace the edited announcemnt in array
        if (this.editingAnnouncement) {
          if (priority) {
            this._gaSvc.register(`Announcements`, `${this._currentUserService.toTitleCase(this.organizationType)} user edited announcement and marked as popup for ${this.activeTab}.`);
          }
          else {
            this._gaSvc.register(`Announcements`, `${this._currentUserService.toTitleCase(this.organizationType)} user edited announcement for ${this.activeTab}.`);
          }

          const indexAn = this.announcements.findIndex(ann => ann._id === this.editingAnnouncement);
          this.announcements[indexAn] = data;
          this.editingAnnouncement = null;
          this.announcements = _.cloneDeep(this.announcements);
        } else {
          // If its adding new announcement append at first index in announcements array
          if (priority) {
            this._gaSvc.register(`Announcements`, `${this._currentUserService.toTitleCase(this.organizationType)} user added new announcement as a popup for ${this.activeTab}.`);
          }
          else {
            this._gaSvc.register(`Announcements`, `${this._currentUserService.toTitleCase(this.organizationType)} user added new announcement for ${this.activeTab}.`);
          }

          this.announcements.unshift(data)
          this.announcements = _.cloneDeep(this.announcements);
        }
        this._flashMessage.updateMessage('Announcement save successful.', 3000, 'success');
      }, () => {
        this._flashMessage.updateMessage('Error while saving announcememnts.');
      });
    }
  }

  /**
   * On EDIT/DELETE clicked on for view announcement
   * @param event
   */
  public onAnnouncementActionClick(event: any): void {
    if (event.action === CRUDActionsEnum.EDIT) {
      this.createNew = false;
      this.editingAnnouncement = event._id
    } else if (event.action === CRUDActionsEnum.DELETE) {
      this._gaSvc.register(`Announcements`, `${this._currentUserService.toTitleCase(this.organizationType)} user deleted announcemnt.`);
      this._deleteAnnouncementSubscriber = this._announcementService.removeAnnouncemnt(event._id).subscribe(() => {
        const filteredAnnouncemnts = this.announcements.filter(ann => ann._id !== event._id)
        this.announcements = _.cloneDeep(filteredAnnouncemnts);
        this._flashMessage.updateMessage('Announcement removed.', 3000, 'success');
      }, () => {
        this._flashMessage.updateMessage('Error while removing announcememnts.');
      });
    }
  }

  /**
   * Load announcements from api call
   */
  private _getAnnouncements(): void {
    this.loading = true;
    this._getAnnouncementSubscriber = this._announcementService.getAnnouncemnts(this.activeTab, this.page).subscribe((announcements: any[]) => {
      // if there are no announcement lock the infinite scroll so that it won't do get api call again
      if (!announcements || !announcements.length) {
        this._lockScroll();
      } else {
        this.announcements = _.concat(this.announcements, announcements)
        this._incrementPage();
        this._cd.detectChanges();
      }
      this.loading = false;
    }, () => {
      this.loading = false;
      this._flashMessage.updateMessage('Error while pulling announcememnts.');
    })
  }

  /**
   * Lock/unlock infinite scroll
   * @param lock
   */
  private _lockScroll(lock: boolean = true) {
    this.lockScroll = lock;
  }

  /**
   * Reset page number to base page
   */
  private _resetPage() {
    this.page = 1;
  }

  /**
   * Increment page number
   * @param count
   */
  private _incrementPage(count: number = 1): void {
    this.page += count;
  }
}
